import { render, staticRenderFns } from "./IconCaretRight.vue?vue&type=template&id=a41fe3c8&scoped=true&"
import script from "./IconCaretRight.vue?vue&type=script&lang=js&"
export * from "./IconCaretRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../dates/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41fe3c8",
  null
  
)

export default component.exports